<template>
    <div class="bottom-confirm">
        <div :class="{content: btns}">
            <div class="top">
                <span class="title">{{title}}</span>
                <img src="../images/close.png" class="close" @click="close">
            </div>
            <slot></slot>
        </div>
        <confirm
            :btns="btns"
            :text="text"
            :cancelText="cancelText"
            @confirm="confirm"
            @cancel="cancel"></confirm>
    </div>
</template>
<script>
import confirm from './confirm.vue'
export default {
    name: 'bottom-confirm',
    components: { confirm },
    props: {
        btns: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '提示'
        },
        text: {
            type: String,
            default: '确定'
        },
        cancelText: {
            type: String,
            default: '取消'
        },
    },
    methods: {
        confirm() {
            this.$emit('confirm')
        },
        cancel() {
            this.$emit('cancel')
        },
        close() {
            this.$emit('close')
        }
    },
}
</script>
<style scoped lang="scss">
    .bottom-confirm{
        padding: .42rem .42rem 1.5rem;
        .top{
            display: flex;
            justify-content: space-between;
            margin-bottom: .5rem;
        }
        .title{
            font-size: .42rem;
            font-weight: 900;
            color: #222;
        }
        .close{
            width: .32rem;
            height: .32rem;
        }
    }
</style>